/* Modulo Feature Spotlight — thumbnail swap + inline-video controls + YouTube/Vimeo lightbox.
   Vanilla IIFE, lazy-init, reduced-motion aware. */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseEmbedUrl(raw) {
    if (!raw) return null;
    var m;
    m = raw.match(/youtu\.be\/([\w-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0';
    m = raw.match(/youtube\.com\/(?:watch\?v=|embed\/)([\w-]{6,})/);
    if (m) return 'https://www.youtube.com/embed/' + m[1] + '?autoplay=1&rel=0';
    m = raw.match(/vimeo\.com\/(\d{5,})/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1';
    return raw;
  }

  function initSection(el) {
    if (el.dataset.fsBound === '1') return;
    el.dataset.fsBound = '1';

    var stageImg = el.querySelector('[data-modulo-fs-stage-img]');
    var thumbs   = el.querySelectorAll('[data-modulo-fs-thumb]');
    var video    = el.querySelector('[data-modulo-fs-video]');
    var pauseBtn = el.querySelector('[data-modulo-fs-pause]');
    var muteBtn  = el.querySelector('[data-modulo-fs-mute]');
    var lightbox = el.querySelector('[data-modulo-fs-lightbox]');
    var lbFrame  = el.querySelector('[data-modulo-fs-lightbox-frame]');
    var lbClose  = el.querySelector('[data-modulo-fs-lightbox-close]');
    var playBtns = el.querySelectorAll('[data-modulo-fs-play]');

    // ─── Thumbnail click → swap stage image (cross-fade) ───
    if (stageImg && thumbs.length) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var src = btn.getAttribute('data-src');
          if (!src) return;
          thumbs.forEach(function (o) { o.classList.toggle('is-active', o === btn); });
          if (REDUCE) {
            stageImg.src = src;
            return;
          }
          stageImg.style.opacity = '0';
          var swap = function () {
            stageImg.removeEventListener('transitionend', swap);
            stageImg.src = src;
            var onLoad = function () {
              stageImg.removeEventListener('load', onLoad);
              stageImg.style.opacity = '1';
            };
            stageImg.addEventListener('load', onLoad);
            requestAnimationFrame(function () { stageImg.style.opacity = '1'; });
          };
          stageImg.addEventListener('transitionend', swap);
        });
      });
    }

    // ─── Inline video controls (pause + mute) ───
    // Icons are pre-rendered in the DOM and toggled via data-state attribute
    // (set in CSS) — no innerHTML manipulation.
    if (video && pauseBtn) {
      pauseBtn.setAttribute('data-state', video.paused ? 'paused' : 'playing');
      pauseBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          pauseBtn.setAttribute('data-state', 'playing');
          pauseBtn.setAttribute('aria-label', 'Pause video');
        } else {
          video.pause();
          pauseBtn.setAttribute('data-state', 'paused');
          pauseBtn.setAttribute('aria-label', 'Play video');
        }
      });
    }
    if (video && muteBtn) {
      muteBtn.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.setAttribute('data-state', video.muted ? 'muted' : 'unmuted');
        muteBtn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      });
    }

    // ─── YouTube / Vimeo / non-autoplay video lightbox ───
    if (lightbox && lbFrame && playBtns.length) {
      function openLightbox(rawUrl) {
        var src = parseEmbedUrl(rawUrl);
        if (!src) return;
        var old = lbFrame.querySelector('iframe, video');
        if (old) old.remove();

        var isFile = /\.(mp4|webm|mov)(\?|$)/i.test(src);
        var node;
        if (isFile) {
          node = document.createElement('video');
          node.src = src;
          node.controls = true;
          node.autoplay = true;
          node.playsInline = true;
        } else {
          node = document.createElement('iframe');
          node.src = src;
          node.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
          node.setAttribute('allowfullscreen', '');
          node.setAttribute('title', 'Product video');
        }
        lbFrame.appendChild(node);
        lightbox.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }
      function closeLightbox() {
        lightbox.hidden = true;
        var n = lbFrame.querySelector('iframe, video');
        if (n) n.remove();
        document.documentElement.style.overflow = '';
      }
      playBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          openLightbox(btn.getAttribute('data-modulo-fs-play'));
        });
      });
      if (lbClose) lbClose.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
      });
    }
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-fs]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-fs]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
